'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { Link } from 'atoms/Link/Link';
import { H2, P } from 'atoms/Typography';
import { YoutubePlayButton } from 'molecules/VideoPlayer/YoutubePlayButton';
import { IVideoTile } from 'pages/StoryBlok/TileBanner/types';
import { NameOfTile } from '../NameOfTile';
import { TileButton } from '../TileButton';
import styles from './YoutubeTile.module.css';

export const YoutubeTile: FC<IVideoTile> = ({ blok, config, videoData }) => {
  const { url = '#', classes, css, buttonText, showName } = config;

  return !videoData || !videoData.preview ? null : (
    <div className={clsx(styles.root, classes)} style={css}>
      <Link
        href={url}
        target="_blank"
        className={styles.media}
        style={{ backgroundImage: `url(${videoData.preview})` }}
        data-tile-name={blok.name}
      >
        <YoutubePlayButton className={styles.playIcon} />
      </Link>
      <div className={styles.content}>
        <div className={styles.textPart}>
          <H2 className={styles.title}>{videoData.title}</H2>
          <P className={styles.description}>{videoData.description}</P>
        </div>
        <TileButton text={buttonText} url={url} />
      </div>
      {showName && <NameOfTile name={blok.name} />}
    </div>
  );
};
